import Notifications from '@/views/notification/Notifications.vue'
import demandModalRouter from '@/router/routers/demandModal'

const notificationRouter = (beforeEnter) => {
    return {
        beforeEnter: beforeEnter,
        name: 'Notificacoes',
        path: '/notificacoes',
        meta: {
            requiresAuth: true,
            breadcrumb: true,
            breadcrumbName: 'Notificações',
            layout: 'default'
        },
        component: Notifications,
        children: [
            demandModalRouter(beforeEnter, 'NotificacaoDetalheDemanda', 'notificacoes/demandas', true)
        ]
    }
}

export default notificationRouter
